import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { DataState, routes } from '@libs/utils';
import { TranslateModule } from '@ngx-translate/core';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { filter, map, tap } from 'rxjs';
import { SiteSetupComponentService } from '../site-setup/site-setup.component.service';

@Component({
  selector: 'lib-external-sign',
  imports: [CommonModule, RouterModule, TranslateModule, LottieComponent],
  templateUrl: './external-sign-page.component.html',
  styleUrl: './external-sign-page.component.scss',
  providers: [SiteSetupComponentService],
})
export class ExternalSignPageComponent implements OnInit {
  public routes = routes;

  private readonly service = inject(SiteSetupComponentService);
  private readonly activatedRoute = inject(ActivatedRoute);
  public DataState = DataState;

  public readonly lottieOptions: AnimationOptions = {
    path: '/assets/animations/loading-spinner.json',
  };

  public vm = this.service.viewModel;

  public ngOnInit(): void {
    this.activatedRoute.queryParams
      .pipe(
        map((parameters) => parameters['contractSignToken']),
        tap((contractSignToken) => {
          if (!contractSignToken) {
            this.service.patchState({ tokenError: true });
          }
        }),
        filter((contractSignToken): contractSignToken is string => !!contractSignToken),
      )
      .subscribe((contractSignToken) => {
        this.service.init(contractSignToken);
      });
  }
}
